module.exports = __webpack_public_path__ + "img/cover-mini-appeau.295dc27c.jpg";